import AppDataTable from './AppDataTable.js';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import DeleteButton from './DeleteButton.js';
import { API_BASE, authHeaders } from '../utils/Utils.js';

export const DataCollection = (props) => {
  const { t } = useTranslation();
  const [refresh, setRefresh] = useState(false);
  const [data, setData] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  const [selectedRows, setSelectedRows] = useState(false);
  const [toggledClearRows, setToggleClearRows] = useState(false);
  const [error, setError] = useState(null);
  const [expandedRowIds, setExpandedRowIds] = useState(new Set());

  const handleRowExpandToggled = (expanded, row) => {
    setExpandedRowIds(prev => {
      const next = new Set(prev);
      if (expanded) next.add(row._id); else next.delete(row._id);
      return next;
    });
    props.onRowExpandToggled?.(expanded, row);
  };

  const handleChange = ({ selectedRows }) => {
    setSelectedRows(selectedRows);
  };

  const handleDeleteComplete = () => {
    setError(null);
    setSelectedRows([]);
    setToggleClearRows(false);
    setRefresh(!refresh);
  }

  const handleDeleteError = (errorMessage) => {
    setError(t('delete_error') + ': ' + errorMessage);
    setSelectedRows([]);
    setToggleClearRows(false);
  }

  useEffect(() => {
    let url = `${API_BASE}/api/data/${props.collection}`;
    if (props.searchFields && Object.keys(props.searchFields).length > 0) {
      const fields = Object.keys(props.searchFields).join(',');
      const values = Object.values(props.searchFields).join(',');
      url += `?search_fields=${encodeURIComponent(fields)}&search_values=${encodeURIComponent(values)}`;
    }
    const fetchData = () => {
      fetch(url, {
        method: 'GET',
        headers: authHeaders({ "Content-Type": "application/json" }),
      })
      .then(response => {
        if (!response.ok) {
          if (response.status === 401) {
            localStorage.removeItem('zapmanejo_token');
            localStorage.removeItem('zapmanejo_user');
            window.location.reload();
          }
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        setData(data);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
    }
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, props.collection, props.forceRefresh, JSON.stringify(props.searchFields)]);

  // filterRow narrows what's shown without refetching (e.g. a page's filter
  // bar); fetching, deleting and refreshing still work on the full set.
  const shown = props.filterRow ? (data || []).filter(props.filterRow) : data;

  const sortField = (props.sortField) ? props.sortField : 1;
  const sortAsc = props.sortAsc !== undefined ? props.sortAsc : true;
  const systemAccount = "000000000000000000000000";

  if (isMobile && props.mobileComponent) {
    return (
      <div className={`DataCollection ${props.collection.charAt(0).toUpperCase() + props.collection.slice(1)}`}>
        {error && <div className="error-message">{error}</div>}
        {props.mobileComponent(shown, () => setRefresh(r => !r))}
      </div>
    );
  }

  return (
    <div className={`DataCollection ${props.collection.charAt(0).toUpperCase() + props.collection.slice(1)}`}>
      <h2>{props.title}</h2>
      {error && <div className="error-message">{error}</div>}
      <AppDataTable
        defaultSortFieldId={sortField}
        defaultSortAsc={sortAsc}
        data={shown}
        columns={props.columns}
        selectableRows
        onSelectedRowsChange={handleChange}
        clearSelectedRows={toggledClearRows}
        keyField="_id"
        expandableRows={props.expandableRows}
        expandableRowsComponent={props.expandableRowsComponent}
        expandableRowExpanded={row => expandedRowIds.has(row._id)}
        onRowExpandToggled={handleRowExpandToggled}
        selectableRowDisabled={row => row.account === systemAccount}
      />
      <DeleteButton
        onComplete={handleDeleteComplete}
        onError={handleDeleteError}
        collection={props.collection}
        data={selectedRows}/>
    </div>
  );
}
export default DataCollection;
